module.exports = __webpack_public_path__ + "static/media/pack-size.402c0309.png";